import React, { useState, useEffect } from 'react';
import { Globe, ChevronDown, Info } from 'lucide-react';

const LanguageSelector = ({ 
  selectedLanguage = 'en', 
  onLanguageChange, 
  detectedLanguage = null,
  showDetected = true,
  compact = false,
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [languages, setLanguages] = useState([
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Spanish' },
    { code: 'fr', name: 'French' },
    { code: 'ru', name: 'Russian' },
    { code: 'fa', name: 'Persian' }
  ]);

  // Fetch available languages on component mount
  useEffect(() => {
    /*const fetchLanguages = async () => {
      try {
        const response = await fetch('/api/supported-languages');
        if (response.ok) {
          const data = await response.json();
          if (data.languages && Array.isArray(data.languages)) {
            setLanguages(data.languages);
          }
        }
      } catch (error) {
        console.error('Error fetching supported languages:', error);
      }
    };
    
    fetchLanguages(); */
  }, []);

  // Handle language selection
  const handleSelect = (languageCode) => {
    if (onLanguageChange && typeof onLanguageChange === 'function') {
      onLanguageChange(languageCode);
    }
    setIsOpen(false);
  };

  // Get language display name from code
  const getLanguageName = (code) => {
    const language = languages.find(lang => lang.code === code);
    return language ? language.name : code;
  };

  const selectedOption = languages.find(lang => lang.code === selectedLanguage) || languages[0];

  return (
    <div className={`relative mb-2 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
      <div className="flex items-center gap-3">
        <Globe className="w-5 h-5 text-gray-500" />
        
        {/* Language selector button */}
        <button
          type="button"
          onClick={() => !disabled && setIsOpen(!isOpen)}
          className={`relative w-48 flex items-center justify-between px-3 py-2 text-left bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-teal-500 focus:border-teal-500 ${
            disabled ? 'cursor-not-allowed' : 'cursor-pointer'
          }`}
          disabled={disabled}
        >
          <span className="block truncate">
            {getLanguageName(selectedLanguage)}
          </span>
          <ChevronDown 
            className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          />
        </button>

        {/* Info button with tooltip */}
        <div className="relative">
          <button
            type="button"
            className="p-1 text-gray-400 hover:text-gray-600 rounded-full focus:outline-none"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onFocus={() => setShowTooltip(true)}
            onBlur={() => setShowTooltip(false)}
            aria-label="Language selection information"
          >
            <Info className="w-4 h-4" />
          </button>
          
          {showTooltip && (
            <div className="absolute z-20 w-64 p-2 mt-2 text-sm text-white bg-gray-800 rounded-md shadow-lg -right-2 top-6">
              Use this to converse in the selected language before recording. The notes produced will be in English.
              <div className="absolute w-3 h-3 bg-gray-800 transform rotate-45 -top-1 right-3"></div>
            </div>
          )}
        </div>

        {/* Dropdown menu */}
        {isOpen && (
          <div className="absolute z-10 mt-1 w-48 bg-white rounded-lg shadow-lg top-full left-8">
            <ul className="py-1 max-h-60 overflow-auto">
              {languages.map((language) => (
                <li
                  key={language.code}
                  onClick={() => handleSelect(language.code)}
                  className={`cursor-pointer select-none relative py-2 px-3 hover:bg-teal-50
                    ${selectedLanguage === language.code ? 'text-teal-600 bg-teal-50' : 'text-gray-900'}
                  `}
                >
                  <span className="block truncate">
                    {language.name}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      
      {/* Detected language indicator */}
      {showDetected && detectedLanguage && selectedLanguage === 'multi' && (
        <div className="mt-1 ml-8 px-2 py-1 bg-blue-50 text-blue-700 text-xs rounded-md border border-blue-100">
          Detected: {getLanguageName(detectedLanguage)}
        </div>
      )}
    </div>
  );
};
export default LanguageSelector;